var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"flex-center header-selector i-menu-expanded",on:{"click":function($event){return _vm.$emit('update:isOpen', !_vm.isOpen)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }